export default __webpack_public_path__ + "static/media/cyclops_4.c29c1282.svg";